type BrandingColor = 'primary' | 'secondary' | 'background' | 'foreground'
type BrandingFont = {
  family: string
}

type ColorConfig = Record<BrandingColor, string>
type FontConfig = BrandingFont

export type Theme = {
  name: string
  colors: ColorConfig
  font: FontConfig
  logoUrl: string
  faviconUrl?: string
  pwaIcon192Url?: string
  pwaIcon512Url?: string
}

export const DEFAULT_THEME: Theme = {
  name: 'nobrinde',
  colors: {
    primary: '#0093D0',
    secondary: '#011e44',
    background: '#ffffff',
    foreground: '#181818',
  },
  font: {
    family: 'Poppins,Open Sans, system-ui, sans-serif',
  },
  logoUrl: '/logo.svg',
  faviconUrl: '/favicon.ico',
  pwaIcon192Url: '/pwa-192.png',
  pwaIcon512Url: '/pwa-512.png',
}
